<template>
    <div class="lead-lost-info ut-flex">
        <div class="ut-w-1/6 ut-text-center">
          <img v-if="infostatus === 'closed'" src="@/assets/images/close-lead.svg" alt="" />
          <img v-if="infostatus === 'lost'" src="@/assets/images/close-lead.svg" alt="" />
          <img v-if="infostatus === 'passedback'" src="@/assets/images/pass-lead.svg" alt="" />
        </div>
        <div class="ut-w-5/6">
            <p class="title">{{ infotitle }}</p>
            <p class="body">{{ infobody }}</p>
        </div>
    </div>
</template>
<script>
export default {
  name: 'LeadUnavailableInfo',
  props: {
    infostatus: {
      default: '',
      required: true,
    },
    infotitle: {
      default: '',
      required: true,
    },
    infobody: {
      default: '',
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.lead-lost-info{
    background-color: #FFFFFF;
    border-top: 1px solid #E3E5E8;
    border-bottom: 1px solid #E3E5E8;
    border-radius: 0px;
    @apply ut-py-6 ut-px-2 ut--mx-4;

    @screen md {
        border: 1px solid #E3E5E8;
        border-radius: 3px;
        @apply ut-py-10 ut-px-8 ut-mx-0;
    }
    .title {
        @apply ut-mb-3;
        color: #2E343B;
        font-family: Lato;
        font-size: 18px;
        @screen md {
          font-size: 20px;
          line-height: 24px;
        }
    }
    .body {
        color: #2E343B;
        font-family: Lato;
        font-size: 14px;
        line-height: 20px;
    }
}
</style>
